import React from "react";
import { Create, translate } from "react-admin";
import HotlineForm from "./HotlineForm";

const HotlineTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("hotline.hotline")}`}</span>;
};

const Title = translate(HotlineTitle);

export const HotlineCreate = props => (
  <Create title={<Title />} {...props}>
    <HotlineForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/hotline/HotlineCreate.js